// extracted by mini-css-extract-plugin
module.exports = {"switchLabVendor":"SwitchLabVendor_switchLabVendor__EENMq","vendorLists":"SwitchLabVendor_vendorLists__w2eAQ","action_btns":"SwitchLabVendor_action_btns__9_A6V"};